import { Link } from "react-router-dom";
import { useLang, CONTACT_EMAILS } from "@/lib/i18n";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";

const Col = ({ title, children }) => (
  <div>
    <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-white/50">{title}</h4>
    <div className="space-y-3 text-[15px]">{children}</div>
  </div>
);

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const link = "block text-white/80 transition-colors hover:text-[#2F7BFF]";
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#04070E] text-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1.2fr_0.8fr] lg:px-8">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-white/60">{f.desc}</p>
        </div>
        <Col title={f.company}>
          {["about", "offer", "vehicles", "brands", "why", "contact"].map((k) => (
            <a key={k} href={k === "vehicles" ? "/vehicles" : `/#${k}`} data-testid={`footer-link-${k}`} className={link}>{t.nav[k]}</a>
          ))}
        </Col>
        <Col title={f.contact}>
          {Object.entries(CONTACT_EMAILS).map(([k, e]) => (
            <a key={k} href={`mailto:${e}`} data-testid={`footer-email-${k}`} className={link}>
              <span className="block text-xs text-white/40">{t.contact.emailLabels[k]}</span>{e}
            </a>
          ))}
        </Col>
        <Col title={f.languages}><LanguageSwitcher light id="footer" /></Col>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between lg:px-8">
          <span>© {new Date().getFullYear()} Autovantis. {f.rights}</span>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-link-privacy" className="transition-colors hover:text-[#2F7BFF]">{f.privacy}</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="transition-colors hover:text-[#2F7BFF]">{f.terms}</Link>
            <Link to="/imprint" data-testid="footer-link-imprint" className="transition-colors hover:text-[#2F7BFF]">{f.imprint}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
